import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useIsInViewport, usePhoneMode } from "../../hooks";
import { useRecentSnapshots } from "../../fetch/fetchMaintenance";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { useNavigate } from "react-router-dom";
import { logFeatureUsage } from "../../fetch/insightsHelper";
import Spinner from "../spinner/Spinner";

dayjs.extend(utc);

export default function RecentSnapshots() {
    const navigate = useNavigate();
    const { phoneMode, isMobile } = usePhoneMode();
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;

    useEffect(() => {
        logFeatureUsage('RecentSnapshots');
        document.title = 'Recent Scans';
    }, []);

    const { items, totalRecords, isLoading, isValidating, size, setSize, error } = useRecentSnapshots({ pageSize: 10 });
    const loadMoreRef = useRef(null);
    const [isInViewport1, _intersectionRatio] = useIsInViewport(loadMoreRef);
    useEffect(() => {
        if (isInViewport1 && !isLoading && !isValidating && items.length < totalRecords) {
            setTimeout(() => {
                setSize(size + 1);
            }, 250);
        }
    }, [isInViewport1, isLoading, isValidating, items.length, totalRecords]);

    return (
        <Grid
            id='scroll-viewer'
            container
            style={{
                position: 'fixed',
                top: scrollViewerTop,
                left: 0,
                height: `calc(100vh - ${scrollViewerTop}px)`,
                overflowX: 'hidden',
                overflowY: 'hidden',
                width: '100vw',
                padding: '1.5em 1em 1.5em 1em'
            }}
        >
            <Grid item xs>
                <Grid container columns={{ xs: 1 }} spacing={2}>
                    <Paper
                        sx={{
                            p: 1.5,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: 'calc(100% - 1em)',
                            marginLeft: '1em',
                            marginTop: '.5em',
                            marginBottom: '1em',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            position: 'relative'
                        }}
                    >
                        <TableContainer style={{ maxHeight: `calc(100vh - ${scrollViewerTop + (isMobile ? 36 : 0)}px - 3.5em)` }}>
                            <Table stickyHeader size={phoneMode ? "small" : "medium"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Scan Time
                                        </TableCell>
                                        <TableCell>
                                            Hull Id
                                        </TableCell>
                                        <TableCell>
                                            Engine Serial(s)
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                Loading...
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        items && items.map((item) => {
                                            const engineSerials = !!item.correctedEngineSerialNumbers ? item.correctedEngineSerialNumbers : item.engineSerialNumbers;
                                            return (
                                                <TableRow key={item.sourceSnapshotId}>
                                                    <TableCell>{dayjs.utc(item.snapshotDate).local().format('L LT')}</TableCell>
                                                    <TableCell>{item.hullId}</TableCell>
                                                    <TableCell>{engineSerials}</TableCell>
                                                    <TableCell>
                                                        <Button onClick={() => navigate(`/literature/service/${item.sourceSnapshotId}/log`)}>Log Service</Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    )}
                                    {items.length === 0 && !isLoading && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">No records found.</TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow style={{ display: items.length < totalRecords ? null : 'none' }} ref={loadMoreRef}>
                                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                            {!isLoading && !isValidating ? (
                                                <Button
                                                    onClick={() => setSize(size + 1)}
                                                >
                                                    Load Next
                                                </Button>
                                            ) : (
                                                <Spinner width={35} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
}
